module.exports = __webpack_public_path__ + "static/media/explicit-content.7343ad99.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/sections/restrictions/explicit-content.png
// module id = 277
// module chunks = 0